//#region Imports
import { getDiscoCompanyMenuItems } from "../../components/AdminCompanySelect/DiscoCompanyMenuItems";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { clampIsoDateToToday, getReportDateInputProps } from "../../utils/reportDateLimits";
//MUI
import {
  Box,
  Button,
  Collapse,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";
import TableChart from "@mui/icons-material/TableChart";
import PrintIcon from "@mui/icons-material/Print";
import Backdrop from "@mui/material/Backdrop";
import AppLoader from '../../components/AppLoader/AppLoader';
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import { useSelector } from "react-redux";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import eOpsLogo from "../../images/eops.png";
import { cfpBaseUrl } from "../../network/urls";
import { openJsPdfInNewTab, convertDate,
  convertDatewithTime,
  printStamp,
  subdivisionName,
  getName,
} from "../../services/Functions";
import "../../style/common.scss";
import "./ChangeOfAttributesStatusReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
import { resolveOfficeCodeForAdmin, getInitialAdminOfficeCode, getEffectiveAdminCompanyCode, resolveReportGoOfficeCode } from "../../utils/adminCompany";
//#endregion

const ChangeOfAttributesStatusReport = () => {
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } =
    useSelector((state) => state.auth);
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [categoryNames, setCategoryNames] = useState("All");
  const [ripeStatusName, setRipeStatusName] = useState("Ripe");
  const [tableData, setTableData] = useState([]);
  const [dateFrom, setDateFrom] = useState(getCurrentDate());
  const [dateTo, setDateTo] = useState(getCurrentDate());
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  const tableRef = useRef(null);
  const [category, setCategory] = useState(3);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (String(code) !== "10") return;
    if (circleCode || selectedDivision || selectedSubDivision) return;
    const company = getEffectiveAdminCompanyCode(
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
    );
    if (company) {
      setOfficeCode(company);
    }
  }, [
    code,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);
  const [officeName, setOfficeName] = useState("");
  const [hierarchy, setHierarchy] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [connectionCategory, setConnectionCategory] = useState("All");
  const [connectionTypeOptions, setConnectionTypeOptions] = useState([]);
  const [ripeStatus, setRipeStatus] = useState(1);
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [expandedMobileRows, setExpandedMobileRows] = useState({});
  const companyCode = code.slice(0, 2);
  const [progressStages, setProgressStages] = useState([]);
const [selectedProgressId, setSelectedProgressId] = useState(100);   // Default = All
const [selectedStageName, setSelectedStageName] = useState("All");
const [selectedChangeTypeId, setSelectedChangeTypeId] = useState(4); 

  const showOldNewApplicantColumns = [1, 4, 5, 6].includes(selectedChangeTypeId);
  const showGuardianColumns = [1, 4, 5, 6].includes(selectedChangeTypeId);
  const showOldNewLoadColumns = [2, 4, 5, 7].includes(selectedChangeTypeId);
  const showOldNewTariffColumns = [3, 4, 6, 7].includes(selectedChangeTypeId);

  const getFirstNonEmptyValue = (item, keys) => {
    for (const key of keys) {
      const value = item?.[key];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }
    return "-";
  };

  const getOldApplicantName = (item) =>
    getFirstNonEmptyValue(item, [
      "currentOwnerName",
      "oldApplicantName",
      "oldapplicantName",
      "applicantOldName",
      "previousApplicantName",
      "currentApplicantName",
      "oldName",
      "applicantNameOld",
      "oldConsumerName",
      "oldCustomerName",
    ]);

  const getNewApplicantName = (item) =>
    getFirstNonEmptyValue(item, [
      "applicantName",
      "newApplicantName",
      "newapplicantName",
      "applicantNewName",
      "updatedApplicantName",
      "newName",
      "applicantName",
      "consumerName",
      "customerName",
    ]);

  const getApplicantName = (item) =>
    getFirstNonEmptyValue(item, [
      "applicantName",
      "currentOwnerName",
      "newApplicantName",
      "consumerName",
      "customerName",
    ]);

  const getGuardianTypeLabel = (type) => {
    const guardianType = Number(type);
    if (guardianType === 1) return "S/O";
    if (guardianType === 2) return "D/O";
    if (guardianType === 3) return "W/O";
    if (guardianType === 4) return "C/O";
    return "-";
  };

  const getGuardianName = (item) =>
    getFirstNonEmptyValue(item, ["applicantGuardianName"]);

  const getOldLoad = (item) =>
    getFirstNonEmptyValue(item, [
      "currentSanctionLoad",
      "oldLoad",
      "previousLoad",
      "sanctionLoad",
      "currentLoad",
      "existingLoad",
      "loadOld",
      "Load",
    ]);

  const getNewLoad = (item) =>
    getFirstNonEmptyValue(item, [
      "newSanctionLoad",
      "newLoad",
      "revisedLoad",
      "appliedLoad",
      "loadRequested",
      "loadNew",
      "Load",
    ]);

  const getLoad = (item) =>
    getFirstNonEmptyValue(item, [
      "Load",
      "newSanctionLoad",
      "currentSanctionLoad",
      "newLoad",
      "oldLoad",
      "sanctionLoad",
    ]);

  const getOldTariff = (item) =>
    getFirstNonEmptyValue(item, [
      "currentTariff",
      "oldTariff",
      "oldTarrif",
      "currentTarrif",
      "existingTariff",
      "existingTarrif",
      "tariffOld",
      "Tarrif",
    ]);

  const getNewTariff = (item) =>
    getFirstNonEmptyValue(item, [
      "newTariff",
      "newTarrif",
      "revisedTariff",
      "revisedTarrif",
      "tariffNew",
      "Tarrif",
    ]);

  const getTariff = (item) =>
    getFirstNonEmptyValue(item, [
      "newTariff",
      "currentTariff",
      "Tarrif",
      "newTarrif",
      "oldTariff",
      "oldTarrif",
    ]);

  const changeRequestTypes = [
    { typeId: 1, typeName: "Change of Name" },
    { typeId: 2, typeName: "Change of Load" },
    { typeId: 3, typeName: "Change of Tariff" },
    { typeId: 4, typeName: "All" },
    { typeId: 5, typeName: "Change of Name | Load" },
    { typeId: 6, typeName: "Change of Name | Tariff" },
    { typeId: 7, typeName: "Change of Load | Tariff" },
  ];

  const offCode = code;
  useEffect(() => {
    if (circleCode) {
      setOfficeCode(circleCode);
    }
  }, [circleCode]);

  // Fetch Application Progress Stages + Add "All" Option
useEffect(() => {
  const fetchProgressStages = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({ applicationTypeId: "15" });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        cfpBaseUrl + "comman/getApplicationProgressIdsByType",
        requestOptions
      );

      const result = await response.json();

      if (result.status === "200" && result.data) {
        // Add "All" option at the beginning
        const stagesWithAll = [
          {
            progressId: 100,
            stepName: "All"
          },
          ...result.data
        ];

        setProgressStages(stagesWithAll);

        // Default to All
        setSelectedProgressId(100);
        setSelectedStageName("All");
      }
    } catch (error) {
    }
  };

  if (token) {
    fetchProgressStages();
  }
}, [token]);
  // Fetch connection types from API
  useEffect(() => {
    const fetchConnectionTypes = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: "",
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "enc/getConnectionTypes",
          requestOptions
        );
        const result = await response.json();

        if (result.status === "200" && result.data) {
          setConnectionTypeOptions(result.data);
        }
      } catch (error) {
      }
    };

    if (token) {
      fetchConnectionTypes();
    }
  }, [token]);


  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setViewBackdrop(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setViewBackdrop(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(
            String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setViewBackdrop(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 4));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
      else if (cfcLevelId == 5) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 5));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  const exportToExcel = () => {
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const Filters = `${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
      category === 1 || category === 2 ? " - " + ripeStatusName : ""
    }`;
    const filename = `${officeName}- From ${dateFrom} - to ${dateTo} - Change-Of-Attributes-Status-Report (${Filters}).xlsx`;
    saveAs(new Blob([wbout]), filename);
  };

  const currentFilters = {
    dateFrom,
    dateTo,
    selectedCompanyCode: code === 10 ? selectedCompanyCode : null,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    connectionCategory,
    selectedProgressId,
    category,
    selectedChangeTypeId,
    ripeStatus: category === 2 ? ripeStatus : null,
    officeCode,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [
    dateFrom,
    dateTo,
    selectedCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
    connectionCategory,
    selectedProgressId,
    category,
    selectedChangeTypeId,
    ripeStatus,
    officeCode,
  ]);

  // نیا Go button handler
  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
    getStats(reportOfficeCode, dateFrom, dateTo, selectedChangeTypeId);
    setLastAppliedFilters({ ...currentFilters });
    setIsGoDisabled(true);
  };
  const connectionTypes = [
    "Sr No.",
    "Application Id.",
    "Registration Date",
    ...(showOldNewApplicantColumns
      ? ["Old Applicant name", "New Applicant name"]
      : ["Applicant Name"]),
    ...(showGuardianColumns ? ["Guardian Type", "Guardian Name"] : []),
    "Phone No.",
    "CNIC.",
    "Premises Address",
    "Reference No.",
    ...(showOldNewLoadColumns ? ["Old Load", "New Load"] : ["Load"]),
    ...(showOldNewTariffColumns ? ["Old Tariff", "New Tariff"] : ["Tariff"]),
    "DN Issue Date",
    "Capital Cost",
    "Security Cost",
    "Total DN Amount",
    "DN Payment Date",
    "S/O Date",
    "SR Date",
    "SR Number",
    "Last Modification Date",
    "Last Modified By",
    "Remarks",
  ];

  const getStats = async (officeCode, dateFrom, dateTo, selectedChangeTypeId) => {
    setViewBackdrop(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        officeCode: officeCode,
        applicationProgressId: selectedProgressId,
        connectionType: connectionCategory,
        status: category,
        ripeUnripe: (category === 0 || category === 1) ? 0 : ripeStatus,
        dateFrom: dateFrom ? dateFrom : "",
        dateTo: dateTo ? dateTo : "",
        changeOfAttributesType: selectedChangeTypeId
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      await fetch(
        cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesStatusReport",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            const data = result.data;
            setTableData(data);
          } else if (result.status === "400") {
            setTableData([]);
          }
        })
        .catch(() => {});
    } catch (e) {
    }
    setViewBackdrop(false);
  };

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = subdivisionName(parseInt(code), subDivisions);
      let dateToPrint = convertDate(new Date());
      let stampData = printStamp(code, offName, name, roleName, dateToPrint);

      const title =
        dateFrom && dateTo && convertDate(dateFrom) === convertDate(dateTo)
          ? `Change Of Attributes Status Report of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
              category === 2 ? " - " + ripeStatusName : ""
            })`
          : `${dateFrom ? convertDate(dateFrom) : "-"} to ${
              dateTo ? convertDate(dateTo) : "-"
            } of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
              category === 2 ? " - " + ripeStatusName : ""
            })`;

      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );
      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(
        `Change Of Attributes Status Report for ${officeName}`,
        pageWidth / 2,
        18,
        { align: "center" }
      );
      pdf.setFontSize(10);
      pdf.text(title, pageWidth / 2, 25, { align: "center" });
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      // PDF should exclude detailed DN/SCO/meter columns — keep concise
      const headers = [
        { content: "Sr No.", styles: { halign: "left" } },
        { content: "Application ID", styles: { halign: "left" } },
        { content: "Applicant Name", styles: { halign: "left" } },
        { content: "Phone No.", styles: { halign: "left" } },
        { content: "CNIC.", styles: { halign: "left" } },
        { content: "Premises Address", styles: { halign: "left" } },
        { content: "Reference No.", styles: { halign: "left" } },
          // { content: "Load", styles: { halign: "left" } },
        { content: "Registration Date", styles: { halign: "left" } },
        { content: "Last Modification Date", styles: { halign: "left" } },
        { content: "Last Modified By", styles: { halign: "left" } },
        { content: "Remarks", styles: { halign: "left" } },
      ];

      let bodyData = [];

      if (tableData && tableData.length > 0) {
        // Build PDF row but exclude DN/SCO/meter columns so PDF is compact
        bodyData = tableData.map((item, index) => [
          { content: index + 1, styles: { halign: "center" } },
          { content: item.applicationId || "-", styles: { halign: "left" } },
          { content: item.applicantName || "-", styles: { halign: "left" } },
          { content: item.applicantPhoneNo || "-", styles: { halign: "left" } },
          { content: item.applicantCNIC || "-", styles: { halign: "left" } },
          { content: item.consumerAddress || "-", styles: { halign: "left" } },
          { content: item.referenceNo || "-", styles: { halign: "left" } },
          // { content: item.Load || "-", styles: { halign: "left" } },
          { content: item.creationDate ? formatDate(item.creationDate) : '-', styles: { halign: "left" } },
          { content: item.lastModificationDate ? formatDate(item.lastModificationDate) : "-", styles: { halign: "left" } },
          { content: item.lastModifiedBy || "-", styles: { halign: "left" } },
          { content: item.remarks || "-", styles: { halign: "left" } },
        ]);
      } else {
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: headers.length,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              textColor: [185, 28, 28],
              fillColor: [254, 226, 226],
            },
          },
        ]);
      }

      pdf.autoTable({
        startY: 28,
        head: [headers],
        body: bodyData,
        styles: {
          cellPadding: 0.5,
          fontSize: 8,
          halign: "left",
          overflow: "linebreak",
        },
        tableWidth: "auto",
        theme: "striped",
        margin: { left: 10, right: 10 },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 30 },
          2: { cellWidth: 37 },
          3: { cellWidth: 23 },
          4: { cellWidth: 23 },
          5: { cellWidth: 40 },
          6: { cellWidth: 23 },
          // 7: { cellWidth: 10 },
          7: { cellWidth: 20 },
          8: { cellWidth: 20 },
          9: { cellWidth: 20 },
          10: { cellWidth: 30 },
        },
      });

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(8);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      const Filters = `${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
        category === 1 || category === 2 ? " - " + ripeStatusName : ""
      }`;

      if (print) {
        openJsPdfInNewTab(pdf, 
          `${officeName}- From ${dateFrom} - to ${dateTo} - Change-Of-Attributes-Status-Report (${Filters}).pdf`
        );
        resolve(pdf);
      } else {
        resolve(pdf);
      }
    });
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date)) return "-";
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options);
  };

  const getDateDifference = (startDate, endDate) => {
    // Convert the date strings to Date objects
    const startDates = startDate.split(",")[0];
    const endDates = endDate.split(",")[0];

    const start = new Date(startDates);
    const end = new Date(endDates);

    // Calculate the difference in time (milliseconds)
    const differenceInTime = end - start;

    // Convert time difference from milliseconds to days
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    return differenceInDays;
  };

  // status change
  const handleStatusChange = (e) => {
    const selectedValue = Number(e.target.value);
    let selectedLabel = "All";
    if (e.target.options && e.target.selectedIndex >= 0) {
      selectedLabel = e.target.options[e.target.selectedIndex].text;
    } else {
      const labels = { 3: "All", 1: "Objected", 0: "Pending", 2: "Accepted" };
      selectedLabel = labels[selectedValue] ?? "All";
    }
    setCategory(selectedValue);
    setCategoryNames(selectedLabel);
  };
  const handleCategoryChange = (e) => {
    const selected = e.target.value;
    setConnectionCategory(selected);
  };

  const handleRipeorUnripeChange = (e) => {
    const selectedValue = Number(e.target.value);
    let selectedLabel = "Ripe";
    if (e.target.options && e.target.selectedIndex >= 0) {
      selectedLabel = e.target.options[e.target.selectedIndex].text;
    } else {
      selectedLabel = selectedValue === 1 ? "Ripe" : "Unripe";
    }

    setRipeStatus(selectedValue);
    setRipeStatusName(selectedLabel);
  };

  const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const tableCaptionText = useMemo(() => {
    const officeLabel =
      officeName && String(officeName).trim() ? String(officeName).trim() : "All offices";
    if (
      dateFrom &&
      dateTo &&
      convertDate(dateFrom) === convertDate(dateTo)
    ) {
      return `Change Of Attributes Status Report for (${officeLabel}) of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
        category === 2 ? " - " + ripeStatusName : ""
      })`;
    }
    return `Change Of Attributes Status Report for (${officeLabel}) from ${
      dateFrom ? convertDate(dateFrom) : "-"
    } to ${dateTo ? convertDate(dateTo) : "-"} of (${connectionCategory} - ${selectedStageName} - ${categoryNames} ${
      category === 2 ? " - " + ripeStatusName : ""
    })`;
  }, [
    dateFrom,
    dateTo,
    officeName,
    connectionCategory,
    selectedStageName,
    categoryNames,
    category,
    ripeStatusName,
  ]);

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
      sx={{
        width: "100%",
        maxWidth: "100%",
        margin: 0,
      }}
    >
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-date-from">Date From</FilterFieldLabel>
          <TextField
            id="coa-date-from"
            hiddenLabel
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateFrom}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateFrom(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-date-to">Date To</FilterFieldLabel>
          <TextField
            id="coa-date-to"
            hiddenLabel
            fullWidth
            size="small"
            variant="outlined"
            type="date"
            value={dateTo}
            inputProps={getReportDateInputProps()}
            onChange={(e) => setDateTo(clampIsoDateToToday(e.target.value))}
          />
        </Stack>
      </Grid>
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-company-select">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-company-select"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={handleChangeCompany}
              >
                <MenuItem value="">
                  <em>Select company</em>
                </MenuItem>
                {getDiscoCompanyMenuItems(selectedCompanyCode)}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-circle-select">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-circle-select"
                displayEmpty
                value={
                  circleCode === "" || circleCode === undefined || circleCode === null
                    ? ""
                    : circleCode
                }
                onChange={handleCircleChange}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-division-select">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-division-select"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={handleDivisionChange}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem key={division.divisionCode} value={division.divisionCode}>
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-subdiv-select">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-subdiv-select"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={handleSubDivisionChange}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-conn-select">Connection Type</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="coa-conn-select"
              value={connectionCategory}
              onChange={handleCategoryChange}
            >
              <MenuItem value="All">All</MenuItem>
              {connectionTypeOptions.map((type) => (
                <MenuItem
                  key={type.connectionTypeId}
                  value={type.connectionTypeName}
                >
                  {type.connectionTypeName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-chg-select">Change Type</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="coa-chg-select"
              value={selectedChangeTypeId}
              onChange={(e) => setSelectedChangeTypeId(parseInt(e.target.value, 10))}
            >
              {changeRequestTypes.map((t) => (
                <MenuItem key={t.typeId} value={t.typeId}>
                  {t.typeName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-stage-select">Current Stage</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="coa-stage-select"
              value={selectedProgressId}
              onChange={(e) => {
                const selectedId = Number(e.target.value);
                setSelectedProgressId(selectedId);
                const selectedStage = progressStages.find(
                  (stage) => stage.progressId === selectedId
                );
                setSelectedStageName(
                  selectedStage ? selectedStage.stepName.trim() : "All"
                );
              }}
            >
              {progressStages.map((stage) => (
                <MenuItem key={stage.progressId} value={stage.progressId}>
                  {stage.stepName.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="coa-status-select">Status</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="coa-status-select"
              value={category}
              onChange={handleStatusChange}
            >
              <MenuItem value={3}>All</MenuItem>
              <MenuItem value={1}>Objected</MenuItem>
              <MenuItem value={0}>Pending</MenuItem>
              <MenuItem value={2}>Accepted</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      {category === 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="coa-ripe-select">Ripe / Unripe</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="coa-ripe-select"
                value={ripeStatus}
                onChange={handleRipeorUnripeChange}
              >
                <MenuItem value={1}>Ripe</MenuItem>
                <MenuItem value={0}>Unripe</MenuItem>
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="coa-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || viewBackdrop}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <Box className="form-box coa-status-report">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">
              Change Of Attributes Status Report
            </h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "#fff",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set dates, office, and options, then run the report.
                  </p>
                )}
              </div>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || viewBackdrop}
                  >
                    GO
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  disabled={tableData.length === 0}
                  startIcon={<PictureAsPdf fontSize="small" />}
                  onClick={() => {
                    if (tableData.length === 0) {
                      noDataAvailable();
                      return;
                    }
                    DownloadPdf(true);
                  }}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  PDF
                </Button>
                <Button
                  variant="outlined"
                  color="success"
                  size="small"
                  disabled={tableData.length === 0}
                  startIcon={<TableChart fontSize="small" />}
                  onClick={() => {
                    if (tableData.length === 0) {
                      noDataAvailable();
                      return;
                    }
                    exportToExcel();
                  }}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Excel
                </Button>
                <Button
                  variant="outlined"
                  color="inherit"
                  size="small"
                  disabled={tableData.length === 0}
                  startIcon={<PrintIcon fontSize="small" />}
                  onClick={() => {
                    if (tableData.length === 0) {
                      noDataAvailable();
                      return;
                    }
                    printPDF();
                  }}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Print
                </Button>
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          {isPhone && (
            <div className="coa-mobile-stack">
              {tableData.length === 0 ? (
                <div className="coa-mobile-empty" role="status">
                  No data for this run. Open <strong>Filters</strong>, tap{" "}
                  <strong>GO</strong>, then check again.
                </div>
              ) : (
                tableData.map((item, id) => {
                  const remarksStr = item.remarks ? String(item.remarks).trim() : "";
                  const applicantLine = showOldNewApplicantColumns
                    ? `${getOldApplicantName(item)} → ${getNewApplicantName(item)}`
                    : getApplicantName(item);
                  const loadLine = showOldNewLoadColumns
                    ? `${getOldLoad(item)} → ${getNewLoad(item)}`
                    : getLoad(item);
                  const tariffLine = showOldNewTariffColumns
                    ? `${getOldTariff(item)} → ${getNewTariff(item)}`
                    : getTariff(item);
                  const expanded = !!expandedMobileRows[id];
                  return (
                    <article key={`m-${id}`} className="coa-mcard">
                      <div className="coa-mcard__top">
                        <div className="coa-mcard__ids">
                          <span className="coa-mcard__sr">#{id + 1}</span>
                          <span className="coa-mcard__aid">{item.applicationId || "—"}</span>
                        </div>
                        <Typography variant="caption" color="text.secondary" display="block">
                          Reg: {item.creationDate ? formatDate(item.creationDate) : "—"}
                        </Typography>
                      </div>
                      <Typography variant="body2" className="coa-mcard__name">
                        {applicantLine}
                      </Typography>
                      <Typography
                        variant="body2"
                        component="div"
                        className="coa-mcard__remarks"
                        sx={{
                          mt: 0.75,
                          color: "text.primary",
                          wordBreak: "break-word",
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {remarksStr ? remarksStr : "—"}
                      </Typography>
                      <dl className="coa-mcard__dl">
                        {showGuardianColumns ? (
                          <>
                            <div>
                              <dt>Guardian Type</dt>
                              <dd>{getGuardianTypeLabel(item.applicantGuardianType)}</dd>
                            </div>
                            <div>
                              <dt>Guardian Name</dt>
                              <dd>{getGuardianName(item)}</dd>
                            </div>
                          </>
                        ) : null}
                        <div>
                          <dt>Phone</dt>
                          <dd>{item.applicantPhoneNo || "—"}</dd>
                        </div>
                        <div>
                          <dt>CNIC</dt>
                          <dd>{item.applicantCNIC || "—"}</dd>
                        </div>
                        <div>
                          <dt>Reference</dt>
                          <dd>{item.referenceNo || "—"}</dd>
                        </div>
                        <div>
                          <dt>Load</dt>
                          <dd>{loadLine}</dd>
                        </div>
                        <div>
                          <dt>Tariff</dt>
                          <dd>{tariffLine}</dd>
                        </div>
                      </dl>
                      <Button
                        size="small"
                        onClick={() =>
                          setExpandedMobileRows((prev) => ({
                            ...prev,
                            [id]: !prev[id],
                          }))
                        }
                        sx={{ alignSelf: "flex-start", textTransform: "none" }}
                      >
                        {expanded ? "Hide financial & workflow" : "Show financial & workflow"}
                      </Button>
                      <Collapse in={expanded}>
                        <dl className="coa-mcard__dl coa-mcard__dl--dense">
                          <div>
                            <dt>Premises</dt>
                            <dd>{item.consumerAddress || "—"}</dd>
                          </div>
                          <div>
                            <dt>DN issue</dt>
                            <dd>{item.issueDate ? formatDate(item.issueDate) : "—"}</dd>
                          </div>
                          <div>
                            <dt>Capital / Security / Total DN</dt>
                            <dd>
                              {item.capitalCostAmount || "—"} / {item.securityDepositeAmount || "—"}{" "}
                              /{" "}
                              {(Number(item.capitalCostAmount) || 0) +
                                (Number(item.securityDepositeAmount) || 0) ||
                                item.dNamount ||
                                item.totalDNAmount ||
                                item.demandNoticeAmount ||
                                "—"}
                            </dd>
                          </div>
                          <div>
                            <dt>DN payment</dt>
                            <dd>{item.paymentDate ? formatDate(item.paymentDate) : "—"}</dd>
                          </div>
                          <div>
                            <dt>SJO / SR / SR #</dt>
                            <dd>
                              {item.sjoCreationDate ? formatDate(item.sjoCreationDate) : "—"} /{" "}
                              {item.storeRequisitionDate ? formatDate(item.storeRequisitionDate) : "—"}{" "}
                              / {item.storeRequisitionNo || "—"}
                            </dd>
                          </div>
                          <div>
                            <dt>Last modified</dt>
                            <dd>
                              {item.lastModificationDate ? formatDate(item.lastModificationDate) : "—"}{" "}
                              · {item.lastModifiedBy || "—"}
                            </dd>
                          </div>
                        </dl>
                      </Collapse>
                    </article>
                  );
                })
              )}
            </div>
          )}

          <div
            className={`coa-table-panel${isPhone ? " coa-table-panel--hide-phone" : ""}`}
          >
            <div className="coa-table-scroll" id="pdf-table">
                    <table
                      className="coa-data-table table"
                      ref={tableRef}
                    >
                      <thead>
                        <tr>
                          {connectionTypes.map((type, index) => (
                            <th key={index} scope="col">
                              {type}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.length > 0 ? (
                          tableData.map((item, id) => (
                            <tr key={id}>
                              <td>{id + 1}</td>
                              <td>
                                {item.applicationId || "-"}
                              </td>
                              <td>
                                {item.creationDate ? formatDate(item.creationDate) : '-'}
                              </td>
                              {showOldNewApplicantColumns ? (
                                <>
                                  <td>
                                    {getOldApplicantName(item)}
                                  </td>
                                  <td>
                                    {getNewApplicantName(item)}
                                  </td>
                                </>
                              ) : (
                                <td>
                                  {getApplicantName(item)}
                                </td>
                              )}
                              {showGuardianColumns ? (
                                <>
                                  <td>
                                    {getGuardianTypeLabel(item.applicantGuardianType)}
                                  </td>
                                  <td>
                                    {getGuardianName(item)}
                                  </td>
                                </>
                              ) : null}
                              <td>
                                {item.applicantPhoneNo || "-"}
                              </td>
                              <td>
                                {item.applicantCNIC || "-"}
                              </td>
                              <td>
                                {item.consumerAddress || "-"}
                              </td>
                              <td>
                                {item.referenceNo || "-"}
                              </td>
                              {showOldNewLoadColumns ? (
                                <>
                                  <td>
                                    {getOldLoad(item)}
                                  </td>
                                  <td>
                                    {getNewLoad(item)}
                                  </td>
                                </>
                              ) : (
                                <td>
                                  {getLoad(item)}
                                </td>
                              )}
                              {showOldNewTariffColumns ? (
                                <>
                                  <td>
                                    {getOldTariff(item)}
                                  </td>
                                  <td>
                                    {getNewTariff(item)}
                                  </td>
                                </>
                              ) : (
                                <td>
                                  {getTariff(item)}
                                </td>
                              )}
                              <td>
                                {item.issueDate ? formatDate(item.issueDate) : "-"}
                              </td>
                              <td>
                                {item.capitalCostAmount || "-"}
                              </td>
                              <td>
                                {item.securityDepositeAmount || "-"}
                              </td>
                              <td>
                                {(
                                  (Number(item.capitalCostAmount) || 0) +
                                  (Number(item.securityDepositeAmount) || 0)
                                ) || item.dNamount || item.totalDNAmount || item.demandNoticeAmount || "-"}
                              </td>
                              <td>
                                {item.paymentDate? formatDate(item.paymentDate) : "-"}
                              </td>
                              <td>
                                {item.sjoCreationDate ? formatDate(item.sjoCreationDate) : "-"}
                              </td>
                              <td>
                                {item.storeRequisitionDate ? formatDate(item.storeRequisitionDate) : "-"}
                              </td>
                              <td>
                                {item.storeRequisitionNo || "-"}
                              </td>
                              <td>
                                {item.lastModificationDate ? formatDate(item.lastModificationDate) : "-"}
                              </td>
                              <td>
                                {item.lastModifiedBy || "-"}
                              </td>
                              <td className="coa-td--remarks">
                                {item.remarks || "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr className="coa-empty-row">
                            <td colSpan={connectionTypes.length}>
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
            </div>
          </div>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: { width: { xs: "100%", sm: 400 }, maxWidth: "100vw", boxSizing: "border-box" },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
};

export default ChangeOfAttributesStatusReport;
